import { Input } from 'antd'
import React, { useState } from 'react'

const TextPicker = ({ onChange }) => {

    const [textValue, setTextValue] = useState('')

    const textValueHandler = (e) => {
        setTextValue(e.target.value)
        onChange(e.target.value)
    }

    return (
        <div>
            <Input.TextArea
                style={{ boxShadow: '0px 3px 6px #0000001A' }}
                placeholder='Add comments'
                rows={4}
                autoSize={{ minRows: 4, maxRows: 4 }}
                value={textValue}
                onChange={textValueHandler}
            />
        </div>
    )
}

export default TextPicker